import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { IncidentDetailPatient } from '../useIncidentDetailForHiroshima';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { convertToPresenceAbsence } from 'core/components/common/converters';
import { FC } from 'react';

type Props = {
  /** 基本情報。 */
  baseInfo: IncidentDetailPatient['baseInfo'];
  /** 搬送先が決まった医療機関名。 */
  determinedHospitalName: string;
};

export const BaseInfoView: FC<Props> = ({ baseInfo, determinedHospitalName }) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="基本情報" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="氏名" content={baseInfo.name} />
          <InfoDisplay title="ふりがな" content={baseInfo.furigana} />
          <InfoDisplay title="性別" content={baseInfo.sex} />
          <InfoDisplay title="生年月日" content={baseInfo.birthday} />
          <InfoDisplay title="年齢" content={baseInfo.age} />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="傷病者住所" content={baseInfo.patientAddress} />
          <InfoDisplay title="傷病者連絡先" content={baseInfo.contactPatient} />
          <InfoDisplay title="傷病者職業" content={baseInfo.occupation} />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="付き添い"
            content={convertToPresenceAbsence(baseInfo.accompanimentPresence)}
          />
          <InfoDisplay
            title="付き添い者(同乗者)"
            content={baseInfo.accompanyingPerson}
          />
          <InfoDisplay
            title="(付き添い者)関係者連絡先"
            content={baseInfo.contactPerson}
          />
          <InfoDisplay title='収容施設' content={determinedHospitalName} />
        </div>
      </div>
    </BorderedContainer>
  );
};
